import { Page } from "containers/Page";
import { TabsGerenciarPagamentosFornecedores } from "./containers/Tabs";

function FornecedorPagamento() {
  return (
    <Page title="Pagamento de fornecedores">
      <TabsGerenciarPagamentosFornecedores />
    </Page>
  );
}

export { FornecedorPagamento };
